module.exports = __webpack_public_path__ + "img/logo.ae78ec5b.png";